import * as React from "react";
import {
  AccessorFn,
  ColumnHelper,
  DeepKeys,
  DisplayColumnDef,
  RowData
} from "@tanstack/react-table";
import styled from "styled-components";

import { formatPrice } from "src/core/prices/utils";
import { Text } from "src/library/components/Text";

/**
 * This function returns a reusable formated column definition for price data to be used in Tanstack tables
 *
 * @param columnHelper
 * @param accessor
 * @param column
 * @returns column definition for price data
 */
export const priceColumn = <TData extends RowData, TAccessor = AccessorFn<TData> | DeepKeys<TData>>(
  columnHelper: ColumnHelper<TData>,
  accessor: TAccessor,
  column: Partial<Pick<DisplayColumnDef<TData>, "header" | "id" | "enableSorting">>
) => {
  return columnHelper.accessor(accessor as DeepKeys<TData>, {
    id: column.id ? column.id : accessor,
    header: column.header ? column.header.toString() : typeof accessor === "string" ? accessor : "",
    cell: info => (
      <TextValueWrapper>
        <Text>
          {formatPrice(info.getValue() as number, 2)}
        </Text>
      </TextValueWrapper>
    ),
    enableSorting: column.enableSorting,
    minSize: 80,
    meta: { style: { align: "right" } }
  } as DisplayColumnDef<TData>);
};

const TextValueWrapper = styled.div`
  text-align: right;
`;
